import type { Components } from "@mui/material";

export const MuiLink: Components["MuiLink"] = {
  defaultProps: {
    underline: "hover",
  },
};
